import type { CheckDepthTier } from '@nestjs-boilerplate/types';

import { useServicePrices } from '@/features/payments';

import { TIER_CONFIGS, TIER_ORDER } from '../constants/tier-config';
import { formatTierPrice, getTierPricePence } from '../lib/tier-pricing';

import { TierCard } from './tier-card';

interface CheckDepthSelectorProps {
  selectedTier: CheckDepthTier | null;
  onSelect: (tier: CheckDepthTier) => void;
}

/**
 * Container component rendering the 3 tier selection cards.
 * Displays Basic, Standard, and Enhanced tiers in a responsive grid.
 */
export function CheckDepthSelector({ selectedTier, onSelect }: CheckDepthSelectorProps) {
  const { data: servicePrices } = useServicePrices();

  return (
    <div
      role="radiogroup"
      aria-label="Select due diligence level"
      className="grid grid-cols-1 gap-4 sm:grid-cols-3"
    >
      {TIER_ORDER.map((tierId) => {
        const tier = TIER_CONFIGS[tierId];
        const pricePence = getTierPricePence(tier, servicePrices);
        return (
          <TierCard
            key={tierId}
            tier={tier}
            priceLabel={formatTierPrice(pricePence)}
            priceLoaded={pricePence !== null}
            isSelected={selectedTier === tierId}
            onSelect={onSelect}
          />
        );
      })}
    </div>
  );
}
